"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _system = require("@mui/system");
var _theme = require("../../../../theme");
var _DividerLine = require("../../../../components/DividerLine");
var _HeaderBar = require("../../../../components/HeaderBar");
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _i18n = _interopRequireDefault(require("../../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../../localization/tokens"));
var _sbUtils = require("@simplybenefits/sb-utils");
var Block = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
var RowCondensedAdjustments = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  padding: "3px 8px"
});
var RowCondensed = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  padding: "3px 8px"
});

/**
 * 
 * @param {*} param0 
 * @returns 
 */
var AdjustmentRow = function AdjustmentRow(_ref) {
  var adjustment = _ref.adjustment,
    style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement(Block, {
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_HeaderBar.HeaderBar, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    color: _theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "".concat(adjustment.meta.lastname, ", ").concat(adjustment.meta.firstname)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    color: _theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "".concat(_i18n["default"].t(_tokens["default"].labels.invoices.certificate), ": ").concat(adjustment.meta.cert)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    color: _theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "".concat(_i18n["default"].t(_tokens["default"].labels.division), ": ").concat(adjustment.meta.divisionName)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    color: _theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "".concat(_i18n["default"].t(_tokens["default"].labels["class"]), ": ").concat(adjustment.meta.className))), adjustment.notes && adjustment.notes.trim().length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(RowCondensed, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true
  }, "$", _i18n["default"].t(_tokens["default"].labels.invoices.notes), ": "), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      marginLeft: 10
    }
  }, adjustment.notes)), /*#__PURE__*/_react["default"].createElement(_DividerLine.DividerLine, null)), adjustment.amounts.life.adjustments instanceof Object ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 2,
      textAlign: 'left'
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.benefit)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.net)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.pst)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.gstHst)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.total))), /*#__PURE__*/_react["default"].createElement(_DividerLine.DividerLine, null), adjustment.amounts.life.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.lifeInsurance)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.life.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.life.adjustments.PST + (adjustment.amounts.life.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.life.adjustments.GST + adjustment.amounts.life.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.life.adjustments.total, 2, true))), adjustment.amounts.add.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.accidentalDeathAndDismemberment)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.add.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.add.adjustments.PST + (adjustment.amounts.add.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.add.adjustments.GST + adjustment.amounts.add.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.add.adjustments.total, 2, true))), adjustment.amounts.ltd.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.longTermDisability)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ltd.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ltd.adjustments.PST + (adjustment.amounts.ltd.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ltd.adjustments.GST + adjustment.amounts.ltd.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ltd.adjustments.total, 2, true))), adjustment.amounts.std.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.shortTermDisability)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.std.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.std.adjustments.PST + (adjustment.amounts.std.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.std.adjustments.GST + adjustment.amounts.std.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.std.adjustments.total, 2, true))), adjustment.amounts.depLife.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.dependentLife)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.depLife.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.depLife.adjustments.PST + (adjustment.amounts.depLife.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.depLife.adjustments.GST + adjustment.amounts.depLife.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.depLife.adjustments.total, 2, true))), adjustment.amounts.ci.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.criticalIllness)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ci.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ci.adjustments.PST + (adjustment.amounts.ci.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ci.adjustments.GST + adjustment.amounts.ci.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ci.adjustments.total, 2, true))), adjustment.amounts.ciSpouse.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.criticalIllnessSpouse)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciSpouse.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciSpouse.adjustments.PST + (adjustment.amounts.ciSpouse.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciSpouse.adjustments.GST + adjustment.amounts.ciSpouse.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciSpouse.adjustments.total, 2, true))), adjustment.amounts.ciChild.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.criticalIllnessChild)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciChild.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciChild.adjustments.PST + (adjustment.amounts.ciChild.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciChild.adjustments.GST + adjustment.amounts.ciChild.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciChild.adjustments.total, 2, true))), adjustment.amounts.health.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.health)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.health.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.health.adjustments.PST + (adjustment.amounts.health.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.health.adjustments.GST + adjustment.amounts.health.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.health.adjustments.total, 2, true))), adjustment.amounts.outOfCountry && adjustment.amounts.outOfCountry.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.outOfCountry)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.outOfCountry.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.outOfCountry.adjustments.PST + (adjustment.amounts.outOfCountry.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.outOfCountry.adjustments.GST + adjustment.amounts.outOfCountry.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.outOfCountry.adjustments.total, 2, true))), adjustment.amounts.stopLoss && adjustment.amounts.stopLoss.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.stopLoss)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.stopLoss.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.stopLoss.adjustments.PST + (adjustment.amounts.stopLoss.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.stopLoss.adjustments.GST + adjustment.amounts.stopLoss.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.stopLoss.adjustments.total, 2, true))), adjustment.amounts.hsa.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.hsa)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.hsa.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.hsa.adjustments.PST + (adjustment.amounts.hsa.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.hsa.adjustments.GST + adjustment.amounts.hsa.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.hsa.adjustments.total, 2, true))), adjustment.amounts.lsa.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.lsa)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.lsa.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.lsa.adjustments.PST + (adjustment.amounts.lsa.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.lsa.adjustments.GST + adjustment.amounts.lsa.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.lsa.adjustments.total, 2, true))), adjustment.amounts.efap.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.efap)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.efap.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.efap.adjustments.PST + (adjustment.amounts.efap.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.efap.adjustments.GST + adjustment.amounts.efap.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.efap.adjustments.total, 2, true))), adjustment.amounts.virtualHealthcare && adjustment.amounts.virtualHealthcare.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.virtualHealthCare)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.virtualHealthcare.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.virtualHealthcare.adjustments.PST + (adjustment.amounts.virtualHealthcare.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.virtualHealthcare.adjustments.GST + adjustment.amounts.virtualHealthcare.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.virtualHealthcare.adjustments.total, 2, true))), adjustment.amounts.dental.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.dental)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.dental.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.dental.adjustments.PST || adjustment.amounts.dental.adjustments.RST || 0, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.dental.adjustments.GST + adjustment.amounts.dental.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.dental.adjustments.total, 2, true))), adjustment.amounts.miscPremiums.adjustments.total !== 0 && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.misc)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.miscPremiums.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.miscPremiums.adjustments.PST + (adjustment.amounts.miscPremiums.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.miscPremiums.adjustments.GST + adjustment.amounts.miscPremiums.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.miscPremiums.adjustments.total, 2, true))), /*#__PURE__*/_react["default"].createElement(_DividerLine.DividerLine, null), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.totalAdjustments)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.totals.adjustments.net, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.totals.adjustments.PST + (adjustment.amounts.totals.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.totals.adjustments.GST + adjustment.amounts.totals.adjustments.HST, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.totals.adjustments.total, 2, true)))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.lifeInsurance)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.life.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.accidentalDeathAndDismemberment)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.add.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.longTermDisability)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ltd.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.shortTermDisability)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.std.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.dependentLife)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.depLife.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.criticalIllness)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ci.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.criticalIllnessSpouse)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciSpouse.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.criticalIllnessChild)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.ciChild.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.health)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.health.adjustments, 2, true))), adjustment.amounts.outOfCountry && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.outOfCountry)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.outOfCountry.adjustments, 2, true))), adjustment.amounts.stopLoss && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.stopLoss)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.stopLoss.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.hsa)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.hsa.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.lsa)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.lsa.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.efap)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.efap.adjustments, 2, true))), adjustment.amounts.virtualHealthcare && /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.virtualHealthCare)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.virtualHealthcare.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.dental)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.dental.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.optional)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.optionalBenefits.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.miscPremiums)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.miscPremiums.adjustments, 2, true))), /*#__PURE__*/_react["default"].createElement(_DividerLine.DividerLine, null), /*#__PURE__*/_react["default"].createElement(RowCondensedAdjustments, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.totalAdjustments)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(adjustment.amounts.totals.adjustments, 2, true)))));
};
var _default = exports["default"] = AdjustmentRow;